var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediaIcon2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 73,
    fill: "none",
    viewBox: "0 0 70 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.95,
    cy: 34.708,
    r: 34.708,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#FF0004",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.875 39.375a4.875 4.875 0 1 1 0-9.75v-3.25c0-.55.14-1.09.406-1.572a1.6 1.6 0 0 0-.406-.053h-5.313a3.25 3.25 0 1 0-6.062-1.625c0 .57.151 1.132.438 1.625h-5.313A1.625 1.625 0 0 0 15 26.375v16.25a1.625 1.625 0 0 0 1.625 1.625h5.313A3.25 3.25 0 1 0 28 45.875c0-.57-.151-1.132-.438-1.625h5.313q.207-.001.406-.053a3.2 3.2 0 0 1-.406-1.572z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.376 24.75h-5.314a3.25 3.25 0 1 1-5.623 0h-5.313a1.625 1.625 0 0 0-1.625 1.625v5.313a3.25 3.25 0 1 0 0 5.623v5.314a1.625 1.625 0 0 0 1.625 1.625h5.313a3.25 3.25 0 1 1 5.623 0h5.314A1.625 1.625 0 0 0 54 42.625v-16.25a1.625 1.625 0 0 0-1.625-1.625"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 15h39v39H15z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 69.416,
    height: 72.434,
    x: 0.242,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.018
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.274167 0 0 0 0 0.30731 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2023_85"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2023_85",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIcon2);
export default __webpack_public_path__ + "static/media/media_icon2.ec435511237273ddcd57dd8fa277f194.svg";
export { ForwardRef as ReactComponent };